---
meta:
  - title: Como usar bases de conocimiento - IUSPRO Docs
  - description: Aprenda qué son las bases de conocimiento y cómo usarlas en clientes, chats, Redactor y agentes.
---

# Como usar bases de conocimiento

Las **bases de conocimiento** le permiten guardar documentos y criterios internos para reutilizarlos en distintas partes
de IUSPRO. Esta funcionalidad está disponible solo en **planes empresariales**.

## 1. Qué es

Una base de conocimiento es un espacio donde usted guarda material que quiere reutilizar muchas veces.

La diferencia con un **cliente** es esta:

- un **cliente** sirve para organizar el trabajo persistente alrededor de un cliente específico, por ejemplo Empresa X
- una **base de conocimiento** sirve para guardar conocimiento técnico interno del bufete que puede reutilizarse en muchos asuntos distintos

Puede servir para:

- criterios internos del despacho
- lineamientos por tipo de asunto
- documentos de apoyo que usa seguido

Para crear una base:

1. Entre a **Base de Conocimiento**
2. Cree una nueva base
3. Suba archivos y cree carpetas para organizarlos

También puede agregar una descripción a cada archivo que sube. Eso ayuda a que el sistema entienda mejor para qué sirve
ese documento y cuándo conviene usarlo.

## 2. Cómo usarlas en los features

Puede usar una base de conocimiento en varios lugares:

- **Clientes**: para dejarla vinculada a un cliente y que los chats de ese cliente la aprovechen
- **Chats**: puede adjuntarla directamente al crear un chat, aunque no tenga cliente
- **Redactor**: puede adjuntarla al iniciar un documento para que la redacción use esos criterios y archivos
- **Agentes**: puede adjuntarla a un agente para que forme parte del contexto que usa al ejecutarse

La idea práctica es simple:

- si el contexto aplica al trabajo completo de un cliente, úsela en **clientes**
- si solo aplica a una conversación, úsela en **chat**
- si quiere que influya en una redacción, úsela en **Redactor**
- si quiere reutilizarla dentro de un proceso armado, úsela en **agentes**
